module.exports = __webpack_public_path__ + "static/media/09_sognolucido.1176a12d.jpg";